export const STROKE_WIDTH = 7;
export const STROKE_COLOR = '#fff';
export const BACKGROUND_IMAGES = {
  COUNT: 15,
  MIN_SCALE: 0.2,
  MAX_SCALE: 1,
  MIN_ROTATION_DEG: 0,
  MAX_ROTATION_DEG: 360,
  MIN_X_PERCENTAGE: 10,
  MAX_X_PERCENTAGE: 90,
  MAX_SIZE: 100,
};
